import React from "react";
import {TableV2, TableOperation} from "@q4us-sw/q4us-ui/lib/TableV2";
import moment from 'moment';
import {
    getFeConfig,
    completeInvoice,
    invoice,
    invoice_udr,
    visualizeLoadInvoice,
    invoiceComment,
    sendEmailForInvoice,
    invoiceCommunicationStatus,
    InvoiceGenericExportReport
} from "../api/api";
import {
    Modal,
    Button,
    Space,
    notification,
    Typography,
    DatePicker,
    Input,
    Tooltip,
    InputNumber,
    Statistic,
    Row, Col
} from 'antd';
import {MapToFilter} from "../utils/mappings";
import {TableFilter} from "./filters/TableFilter";
import {
    FilePdfOutlined,
    CheckCircleOutlined,
    MailOutlined,
    FileTextOutlined,
    StopOutlined,
    CommentOutlined,
    CheckCircleFilled, AppstoreAddOutlined
} from "@ant-design/icons";
import {Q4USUtil} from "@q4us-sw/q4us-util";
import { TableContext, RowContext} from "@q4us-sw/q4us-ui/lib/TableV2";
import '../styles/InvoiceListView.css';

const {TextArea} = Input

export const InvoiceListView = () => {

    const fetchData = async (values, page = {})=>{
        const filters = MapToFilter(values)
        const data = await visualizeLoadInvoice({
            tableName: 'invoice_list_info',
            orderBy: ['timestamp desc'],
            filter:[...filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
        const {data: {page: {total, total_invoiced_amount_in_eur_invoices, total_paid_amount_in_eur, balance_in_eur} = {}} = {}} = data;
        setTotal({
            total: total,
            total_invoiced_amount_in_eur_invoices: Q4USUtil.roundToDecimal(total_invoiced_amount_in_eur_invoices),
            total_paid_amount_in_eur: Q4USUtil.roundToDecimal(total_paid_amount_in_eur),
            balance_in_eur: Q4USUtil.roundToDecimal(balance_in_eur)
        })
        return data
    }

    const [paid, setPaid] = React.useState({
        invoice_id:null,
        visible:false,
        payment_date: moment(),
        amount: 0.00,
        paid_amount: 0.00,
        status: '',
        title: '',
        prompt_visible: false,
        prompt_msg: ''
    });
    const [comment, setComment] = React.useState({
        invoice_id:null,
        comment_content: '',
        visible: false
    });

    const [total, setTotal] = React.useState({
        total: 0,
        total_invoiced_amount_in_eur_invoices: 0,
        total_paid_amount_in_eur: 0,
        balance_in_eur: 0,
    });

    return <React.Fragment>
        <div className={`invoice-list-view`}>
            <TableV2
                header={

                        <React.Fragment>
                            <div className={"eas-header"}>
                                <div className={"title ant-page-header-heading-title"}>EM Invoices</div>
                            </div>
                            <TableFilter
                                schema={'invoice_list_info_filter'}
                                fetch={fetchData}
                                initialValue={{
                                    from_timestamp: moment().startOf("year"),
                                    to_timestamp: moment()
                                }}
                            />
                            <TableContext.Consumer>
                                {button => <div style={{padding: "5px", align: "right"}}>
                                    <Button type={"primary"} onClick={async () => {
                                        const {filter} = button.customData
                                        const filters = MapToFilter(filter);
                                        await InvoiceGenericExportReport({table_name: 'invoice_list_info', filter: [...filters]})
                                    }}>
                                        Export to excel
                                    </Button>
                                </div>}
                            </TableContext.Consumer>
                        </React.Fragment>
                }

                minColumnWidth={120}
                maxColumnWidth={250}

                action={{
                    options: TableOperation.Custom,
                    minWidth: 45
                }}

                getCustomAction={(o) => {
                    return <RowContext.Consumer>
                        {row => <TableContext.Consumer>
                            {table => <Space>
                                {row?.row && <Tooltip title={"Download invoice in PDF"}>
                                    <Button onClick={async () => {
                                        await invoice(row?.row.em_id, row?.row.invoice_id, `Invoice ${row?.row.invoice_number}-${row?.row.client_number}.pdf`)
                                    }} icon={<FilePdfOutlined/>}/>
                                </Tooltip>}

                                {row?.row && <Tooltip title={"Mark as paid or edit payment information"}>
                                    <Button onClick={() => {
                                        if (row?.row.payment_status === 'paid' || row?.row.payment_status === 'partially_paid') {
                                            setPaid({
                                                invoice_id: row?.row.invoice_id,
                                                visible: true,
                                                payment_date: moment(row?.row.date_of_payment),
                                                amount: Q4USUtil.roundToDecimal(row?.row.total_invoice_amount_in_eur),
                                                paid_amount: Q4USUtil.roundToDecimal(row?.row.paid_amount),
                                                status: row?.row.payment_status,
                                                title: 'Edit Payment',
                                                prompt_visible: false,
                                                prompt_msg: ''
                                            })
                                        } else {
                                            setPaid({
                                                invoice_id: row?.row.invoice_id,
                                                visible: true,
                                                payment_date: moment(),
                                                amount: Q4USUtil.roundToDecimal(row?.row.total_invoice_amount_in_eur),
                                                paid_amount: Q4USUtil.roundToDecimal(row?.row.total_invoice_amount_in_eur),
                                                status: row?.row.payment_status,
                                                title: 'Payment Completion',
                                                prompt_visible: false,
                                                prompt_msg: ''
                                            })
                                        }
                                    }} icon={(row?.row.payment_status === 'paid' ? <CheckCircleFilled
                                        color={"#52c41a"}/> : row?.row.payment_status === 'partially_paid' ?
                                        <CheckCircleFilled color={"#ffec3d"}/> : row?.row.payment_status === 'overdue' ?
                                            <CheckCircleOutlined color={"#ff4d4f"}/> : <CheckCircleOutlined/>)}
                                            style={{color: row?.row.payment_status === 'paid' ? "#52c41a" : row?.row.payment_status === 'partially_paid' ? "#ffec3d" : row?.row.payment_status === 'overdue' ? "#ff4d4f" : "#262626"}}
                                    />
                                </Tooltip>}

                                {row?.row && <Tooltip title={"Send notification to client"}>
                                    <Button onClick={async () => {
                                        await sendEmailForInvoice(row?.row.em_id, row?.row.invoice_id, row?.row.invoice_number,
                                            row?.row.timestamp, row?.row.client_number, row?.row.due_date, row?.row.reference_number,
                                            row?.row.payment_status, row?.row.communication_status,
                                            row?.row.total_invoice_amount_in_eur, row?.row.paid_amount);
                                    }} icon={<MailOutlined/>} disabled={(row?.row.payment_status === 'paid')}/>
                                </Tooltip>}

                                {row?.row && <Tooltip title={"Download Invoice appendix in CSV"}>
                                    <Button onClick={async () => {
                                        await invoice_udr(row?.row.em_id, row?.row.invoice_id, row?.row.invoice_duration)
                                    }} icon={<FileTextOutlined/>}/>
                                </Tooltip>}

                                {row?.row && <Tooltip title={"Suspend notifications on invoice payments"}>
                                    <Button onClick={async () => {
                                        await invoiceCommunicationStatus({
                                            invoice_id: row?.row.invoice_id,
                                            communication_status: "suspended"
                                        });
                                    }} icon={<StopOutlined/>}/>
                                </Tooltip>}

                                {row?.row && <Tooltip title={"Add or edit comments for the invoice"}>
                                    <Button onClick={() => {
                                        if (row?.row.invoice_id) {
                                            setComment({
                                                invoice_id: row?.row.invoice_id,
                                                visible: true,
                                                comment_content: row?.row.comment
                                            })
                                        }
                                    }} icon={(row?.row.comment==='' || row?.row.comment===null) ? <CommentOutlined style={{color:"black"}}/> : <CommentOutlined style={{color:"blue"}}/>} />
                                </Tooltip>}

                            </Space>}
                        </TableContext.Consumer>}
                    </RowContext.Consumer>
                }}

                fetchConfig={async (schema) => {
                    const {data= {}} = await getFeConfig(schema)
                    const { statusCode, rows = [], fields = [] } = data;

                    rows.unshift({
                            name: "id_no", title: "#", width: 200, formatter: (row, index, name, type, formatted, value) => {
                                return <Space key={index}>
                                    <Typography.Text>{index == -1 ? index+2 : index+1}</Typography.Text>
                                </Space>;
                            }
                        }
                    );

                    return {data:{statusCode, rows, fields}};
                }}

                schema={"invoice_list_info"}
                fetchData={async (request) => {
                    return await fetchData(request.options.filter || {}, request.page);
                }}
                scroll={{x: 'max-content',y:'calc(100vh - 125px - 134px - 210px)'}}
            >
                    <Space className={"custom-space-content"} direction={`vertical`} style={{backgroundColor: "white", width: "100%", padding:"0px 10px", margin:"0px 15px"}}>
                        <Row gutter={{xs: 8, sm: 16, md: 24, lg: 80, xl:192} } style={{}}>
                            <Col>
                                <Statistic title={"Invoice count"} value={total.total}/>
                            </Col>
                            <Col>
                                <Statistic title={"Total invoiced (EUR)"} value={total.total_invoiced_amount_in_eur_invoices}/>
                            </Col>
                            <Col>
                                <Statistic title={"Paid amount (EUR)"} value={total.total_paid_amount_in_eur}/>
                            </Col>
                            <Col>
                                <Statistic title={"Balance (EUR)"} value={total.balance_in_eur}
                                           valueStyle={(total.balance_in_eur < 0) ? {color: '#cf1322'} : {color: 'black'}}/>
                            </Col>
                        </Row>
                    </Space>

            </TableV2>
        </div>

        <Modal
            centered={true}
            closable={true}
            onCancel={() => {setPaid({
                invoice_id:null,
                visible:false,
                payment_date: moment(),
                amount: 0,
                paid_amount: 0,
                status: '',
                title: '',
                prompt_visible: false,
                prompt_msg: ''
            })}}
            visible={paid.visible}
            onOk={async () => {
                if (paid.amount === paid.paid_amount) {
                    const {prompt_visible, prompt_msg, ...args} = paid
                    setPaid({
                        ...args,
                        prompt_msg: 'Please confirm invoice payment',
                        prompt_visible: true
                    })
                }
                else if (paid.paid_amount === 0) {
                    const {prompt_visible, prompt_msg, ...args} = paid
                    setPaid({
                        ...args,
                        prompt_msg: `Payment amount ${paid.paid_amount} differs from Total Invoice Amount ${paid.amount}. Please confirm invoice payment`,
                        prompt_visible: true
                    })
                }
                else {
                    const {prompt_visible, prompt_msg, ...args} = paid
                    setPaid({
                        ...args,
                        prompt_msg: `Payment amount ${paid.paid_amount} differs from Total Invoice Amount ${paid.amount}. Please confirm invoice payment`,
                        prompt_visible: true
                    })
                }
            }}
            title={paid.title}
        >
            <table>
                <tr style={{paddingBottom: 10}}>
                    <td style={{padding: 12}}><Typography.Text>Payment Date</Typography.Text></td>
                    <td style={{padding: 12}}><DatePicker value={paid.payment_date} onChange={(date)=>{
                        setPaid({...paid, payment_date: date})
                    }}/></td>
                </tr>
                <tr>
                    <td style={{padding: 12}}><Typography.Text>Amount paid(EUR)</Typography.Text></td>
                    <td style={{padding: 12}}><InputNumber value={paid.paid_amount} min={0.00} precision={2} onChange={(e)=>{
                        setPaid({...paid, paid_amount: e})
                    }}/></td>
                </tr>
            </table>
        </Modal>

        <Modal
            centered={true}
            closable={true}
            onCancel={() => {setComment({
                invoice_id:null,
                visible: false,
                comment: comment.comment_content
            })}}
            visible={comment.visible}
            onOk={async () => {
                const { visible, ...args} = comment;
                const {status} = await invoiceComment({...args});
                setComment({
                    ...comment,
                    visible: false
                })
                if (status === 200) {
                    notification.success({message: `Comment entered successfully`});
                }
                else {
                    notification.error({message: `We received ${status} error`});
                }
            }}
            title={"Enter your comment"}
        >
            <TextArea placeholder={"Enter your comment"} value={comment.comment_content} onChange={(e) => {setComment({ ...comment, comment_content: e.target.value})}}/>
        </Modal>

        <Modal
            centered={true}
            closable={true}
            visible={paid.prompt_visible}
            onCancel={() => {
                const {prompt_visible, ...args} = paid;
                setPaid({
                    ...args,
                    visible: false,
                    prompt_visible: false
                })
            }}
            onOk={async ()=>{
                const {prompt_visible, visible, prompt_msg, title, status, ...args } = paid
                const res = await completeInvoice({...args})
                if (res.status === 200) {
                    notification.success({message: `Payment details entered successfully`})
                }
                else {
                    notification.error({message: `Request failed with ${res.status} error`});
                }
                setPaid({
                    ...args,
                    visible: false,
                    prompt_visible: false
                })
            }}
        >
            <p>{paid.prompt_msg}</p>
        </Modal>
    </React.Fragment>
};
